<template>
  <div>
    <div class="col-sm-12">
      <el-table
        stripe
        :cell-style="cellStyle"
        :span-method="objectSpanMethod"
        :default-sort="defaultSort"
        style="width: 100%"
        :data="infoTable"
        :border="true"
        :max-height="maxHeight"
      >
        <el-table-column
          type="index"
          width="65"
          :fixed="indexColumn.fixed ? indexColumn.fixed : false"
          v-if="indexColumn.show"
        ></el-table-column>
        <slot name="appendColumns"></slot>
        <template v-for="column in columns">
          <template v-if="isComponentFormatter(column.formatter)">
            <el-table-column
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :sortable="column.sortable"
              :align="column.align"
              :fixed="column.fixed"
              :resizable="false"
              v-if="showColumn(column.show)"
            >
              <template
                slot-scope="props"
                v-if="validateTypeFormatter(column.formatter)"
              >
                <div
                  v-if="column.formatter"
                  :is="column.formatter"
                  :row="props.row"
                  :column="column.prop"
                ></div>
                <template v-else>
                  {{ getProperty(props.row, column.prop) }}
                </template>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              :formatter="getFormatter(column.formatter)"
              :sortable="column.sortable"
              :align="column.align"
              :fixed="column.fixed"
              :resizable="false"
              v-if="showColumn(column.show)"
            >
              <el-table-column
                v-for="column in column._columns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop ? column.prop : 'na'"
                :label="column.label"
                :formatter="getFormatter(column.formatter)"
                :sortable="column.sortable"
                :align="column.align"
                :fixed="column.fixed"
                :resizable="false"
              />
            </el-table-column>
          </template>
        </template>
        <slot name="addColumns"></slot>
        <el-table-column
          v-if="showColumnImage"
          label="Imagen"
          min-width="150"
          :resizable="false"
        >
          <template slot-scope="scope">
            <image-with-zoom
              v-if="scope.row.image"
              :urlFile="scope.row.image"
              :diskName="scope.row.disk ? scope.row.disk : ''"
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="showColumnStatus"
          :min-width="widthColumnStatus"
          :label="$t('common_words.status')"
          :align="'center'"
          :sortable="true"
          :resizable="false"
        >
          <template slot-scope="scope">
            <el-tag :type="`${scope.row.deleted_at ? 'warning' : 'info'}`">{{
              scope.row.deleted_at
                ? $t('common_words.disable')
                : $t('common_words.enable')
            }}</el-tag>
          </template>
        </el-table-column>
        <slot name="addColumnsOperations"></slot>
      </el-table>
    </div>
  </div>
</template>
<script>
import ImageWithZoom from '../ImageWithZoom.vue';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  name: 'master-table',
  mixins: [MixinPermissions],
  components: {
    [ImageWithZoom.name]: ImageWithZoom,
  },
  props: {
    cellStyle: {
      type: Function,
      default: () => {
        return '';
      },
    },
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultSort: {
      type: Object,
      default: () => {
        return { prop: 'name', order: 'descending' };
      },
    },
    indexColumn: {
      type: Object,
      default: () => {
        return { show: false, fixed: false };
      },
    },
    infoTable: {
      type: Array,
      default: [],
    },
    maxHeight: {
      type: Number,
      default: 500,
    },
    objectSpanMethod: {
      type: Function,
      default: () => {
        return {
          rowspan: 1,
          colspan: 1,
        };
      },
    },
    showColumnImage: {
      type: Boolean,
      default: false,
    },
    showColumnStatus: {
      type: Boolean,
      default: false,
    },
    widthColumnStatus: {
      type: String | Number,
      default: 140,
    },
  },
  methods: {
    showColumn(show) {
      if (typeof show === 'undefined') return true;
      else if (typeof show !== 'undefined' || show !== null) return show;
    },
    handleCellStyle(data) {
      this.cellStyle(data);
    },
    validateTypeFormatter(value) {
      if (typeof value !== 'function') {
        return true;
      }

      return false;
    },
    getProperty(data, property) {
      if (!data[property]) {
        const keys = property.toLowerCase().split('.');
        let result = null;
        keys.forEach((key, i) => {
          if (i === 0) result = data[key];
          else result = result[key];
        });

        return result;
      } else return data[property];
    },
    getFormatter(formatter) {
      if (typeof formatter === 'function') return formatter;
      else return null;
    },
    isComponentFormatter(formatter) {
      return typeof formatter === 'object';
    },
  },
};
</script>
